import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconInfo({
  extColor,
  isAutoscallable = true,
  sizeKey = '10x10',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 10 10"
      fill={fill}
    >
      <path d="M5.00065 7.08301C5.11871 7.08301 5.21767 7.04308 5.29753 6.96322C5.37739 6.88336 5.41732 6.7844 5.41732 6.66634C5.41732 6.54829 5.37739 6.44933 5.29753 6.36947C5.21767 6.28961 5.11871 6.24967 5.00065 6.24967C4.8826 6.24967 4.78364 6.28961 4.70378 6.36947C4.62392 6.44933 4.58398 6.54829 4.58398 6.66634C4.58398 6.7844 4.62392 6.88336 4.70378 6.96322C4.78364 7.04308 4.8826 7.08301 5.00065 7.08301ZM4.58398 5.41634H5.41732V2.91634H4.58398V5.41634ZM5.00065 9.16634C4.42426 9.16634 3.8826 9.05697 3.37565 8.83822C2.86871 8.61947 2.42773 8.32259 2.05273 7.94759C1.67773 7.57259 1.38086 7.13162 1.16211 6.62467C0.943359 6.11773 0.833984 5.57606 0.833984 4.99967C0.833984 4.42329 0.943359 3.88162 1.16211 3.37467C1.38086 2.86773 1.67773 2.42676 2.05273 2.05176C2.42773 1.67676 2.86871 1.37988 3.37565 1.16113C3.8826 0.942383 4.42426 0.833008 5.00065 0.833008C5.57704 0.833008 6.11871 0.942383 6.62565 1.16113C7.1326 1.37988 7.57357 1.67676 7.94857 2.05176C8.32357 2.42676 8.62044 2.86773 8.83919 3.37467C9.05794 3.88162 9.16732 4.42329 9.16732 4.99967C9.16732 5.57606 9.05794 6.11773 8.83919 6.62467C8.62044 7.13162 8.32357 7.57259 7.94857 7.94759C7.57357 8.32259 7.1326 8.61947 6.62565 8.83822C6.11871 9.05697 5.57704 9.16634 5.00065 9.16634ZM5.00065 8.33301C5.93121 8.33301 6.7194 8.01009 7.36523 7.36426C8.01107 6.71842 8.33398 5.93023 8.33398 4.99967C8.33398 4.06912 8.01107 3.28092 7.36523 2.63509C6.7194 1.98926 5.93121 1.66634 5.00065 1.66634C4.0701 1.66634 3.2819 1.98926 2.63607 2.63509C1.99023 3.28092 1.66732 4.06912 1.66732 4.99967C1.66732 5.93023 1.99023 6.71842 2.63607 7.36426C3.2819 8.01009 4.0701 8.33301 5.00065 8.33301Z" />
    </svg>
  );
}
